'use client';

import { useSuspenseQuery } from '@tanstack/react-query';

import { UnauthQueryOptions } from '@/api';
import { WEBVIEW_TYPE_ENTRY } from '@/constants';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';

import { filterMainBannerItems } from '../../_utils/filterMainBannerItems';
import { DesktopMainBannerSection } from '../DesktopMainBannerSection';

interface MainBannerSectionClientProps {
  className?: string;
}

export const MainBannerSectionClient = ({
  className,
}: MainBannerSectionClientProps) => {
  const { entry } = useWebviewTypeEntry();

  const { data: bannerItems } = useSuspenseQuery({
    ...UnauthQueryOptions[
      'get:/wello/v2/allows/home/institution-event/ordered'
    ]({
      query: {
        excludeEndedYN: true,
        entry,
      },
    }),
    select: (res) => {
      const list = res.context?.contents ?? [];

      return filterMainBannerItems(list, entry);
    },
    retry: 3,
  });

  const LOCAL_MARKET_BANNER = {
    href: '/welmarket',
    title: '웰마켙 오픈',
    imageUrl:
      'https://cdn.welfarehello.com/static/local-market/home/hero-banner-pc-bg-1.png',
  };

  const resolvedBannerItems =
    entry === WEBVIEW_TYPE_ENTRY.WELLO
      ? [LOCAL_MARKET_BANNER, ...bannerItems]
      : bannerItems;

  return (
    <DesktopMainBannerSection
      bannerItems={resolvedBannerItems}
      className={className}
    />
  );
};
